module.exports = __webpack_public_path__ + "static/media/N15.3a88c0d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/N15.svg
// module id = 194
// module chunks = 0